<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div class="row">
      <div class="col">
        <router-link to="/profile">Retour</router-link>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h1>Changer l'image de votre profil</h1>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12 col-md-6">
        <h2>Image actuelle </h2>
        <img v-bind:src="picture" width="256" v-if="picture"/>
        <img src="../../assets/default-profile.png" v-else width="256"/>
      </div>
      <div class="col-12 col-md-6 mt-4 mt-md-0">
        <h2>Choisissez une image</h2>
        <canvas ref="imageUploaded" v-bind:class="vueCanva"></canvas>
        <div v-if="initialState">
          <div class="dropbox">
            <input ref="fileupload" type="file" name="picture" id="picture"
            accept="image/jpeg, image/jpg"
            v-on:change="onFileChanged" class="input-file"/>
            <p>
              Faites glisser votre image ici<br>
              ou cliquer pour rechercher une image<br />
              au format jpg.
            </p>
          </div>
          <p class="mt-2">Pour un résultat optimum il
            faut mettre une photo carré aux dimension minimum de 256 * 256 px. </p>
          <a href="https://croppola.com/" target="_blank" class="mt-2">Voici un lien pour redécouper une photo.</a>
        </div>
        <div v-else>
          <span v-if="uploading">Téléchargement en cours</span>
          <div class="row mt-4" v-else>
            <div class="col-4">
              <button type="button"
                  class="btn btn-link btn-disabled"
                  @click="reset()">Annuler</button>
            </div>
            <div class="col-4 text-end">
              <button type="button"
                  class="btn btn-link"
                  @click="submitFile()">Valider</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>
<script>
import EXIF from 'exif-js';
import iam from '../../iam';
import LoggedUser from '../LoggedUser.vue';
import BottomNav from '../BottomNav.vue';

export default {
  name: 'ChangePicture',
  data() {
    return {
      picture: undefined,
      imageSource: undefined,
      uploading: false,
      initialState: true,
    };
  },
  computed: {
    vueCanva() {
      return {
        'd-none': this.initialState,
      };
    },
  },
  components: { LoggedUser, BottomNav },
  mounted() {
    const canvas = this.$refs.imageUploaded;
    canvas.width = 256;
    canvas.height = 256;
  },
  created() {
    this.picture = iam.getConnectedUser().picture;
  },
  methods: {
    reset() {
      this.initialState = true;
    },
    onFileChanged(e) {
      const vm = this;
      const fr = new FileReader();
      const fileReaderBuffer = new FileReader();
      let rotation;

      fr.onload = (ev) => {
        vm.imageSource = new Image();
        vm.imageSource.id = 'target';
        vm.imageSource.onload = () => {
          const canvas = this.$refs.imageUploaded;
          this.renderImageInCanvas(canvas, vm.imageSource, rotation);
          this.initialState = false;
        };
        vm.imageSource.src = ev.target.result;
      };

      fileReaderBuffer.onload = (ev) => {
        const canvas = this.$refs.imageUploaded;
        const ctx = canvas.getContext('2d');
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const exif = EXIF.readFromBinaryFile(ev.target.result);
        switch (exif.Orientation) {
          case 6:
            // 90° rotate right
            rotation = 0.5 * Math.PI;
            break;
          case 8:
            // 90° rotate left
            rotation = -0.5 * Math.PI;
            break;
          default: break;
        }
      };
      fileReaderBuffer.readAsArrayBuffer(e.target.files[0]);
      fr.readAsDataURL(e.target.files[0]);
    },
    renderImageInCanvas(canvas, imageSource, rotation) {
      const imageHeight = imageSource.height;
      const imageWidth = imageSource.width;
      let destHeight; // hauteur de l'image finale dans le  caneva
      let destWidth;
      const ratio = imageWidth / imageHeight;
      let ratioCanvas = canvas.width / canvas.height;
      if (rotation) {
        ratioCanvas = canvas.height / canvas.width;
      }
      if (ratio <= ratioCanvas) { // image verticale
        destHeight = rotation ? canvas.width : canvas.height;
        destWidth = destHeight * ratio;
      } else { // image horizontale
        destWidth = rotation ? canvas.height : canvas.width;
        destHeight = destWidth / ratio;
      }
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = 'black';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.translate(canvas.width / 2, canvas.height / 2); // center of canvas
      if (rotation) {
        ctx.rotate(rotation);
      }
      ctx.drawImage(imageSource, -destWidth / 2, -destHeight / 2, destWidth, destHeight);
    },
    submitFile() {
      this.uploading = true;
      const canvas = this.$refs.imageUploaded;
      const dataURL = canvas.toDataURL('image/jpeg');
      this.$http.post(`${import.meta.env.VITE_LCT_API_URL}/pictures`, {
        base64File: dataURL,
      }).then((response) => {
        this.uploading = false;
        const user = iam.getConnectedUser();
        user.picture = response.data.picture;
        iam.setConnectedUser(user);
        this.goToProfile();
      });
    },
    goToProfile() {
      this.$router.push('/profile');
    },
  },
};
</script>
<style scoped>
.thumbnails{
  list-style-type: none;
  padding-left: 0;
}
.thumbnails li{
  margin-bottom: 20px;
}
.thumbnails li .md-button{
  margin-top: 90px;
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: #e2fbf0;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
.btn-link{
  color: #CE0F69;
}
.btn-disabled {
  color: #595959;
}
</style>
